module.exports = __webpack_public_path__ + "128e6b46674a353a5df32045b583c0b3.svg";